module.exports = __webpack_public_path__ + "static/media/icone-legislacao.94fc03cf.svg";